(function () {
  function isDesktop() {
    return !window.matchMedia("(max-width: 767px)").matches;
  }

  function getOriginalLink() {
    return document.querySelector(".header__secondary-nav .header__search-link a");
  }

  function getPrimaryList() {
    return document.querySelector(".header__primary-nav ul.contents.unstyled-list");
  }

  function getTranslatedSearchLabel(originalLink) {
    // Best source: the theme's own translated sr-only text
    if (originalLink) {
      var sr = originalLink.querySelector(".sr-only");
      if (sr && sr.textContent && sr.textContent.trim()) return sr.textContent.trim();

      var aria = originalLink.getAttribute("aria-label");
      if (aria && aria.trim()) return aria.trim();
    }

    // Fallback to <html lang="..">
    var lang = (document.documentElement.getAttribute("lang") || "").toLowerCase();
    if (lang.startsWith("es")) return "Buscar";
    return "Search";
  }

  function ensureInjectedButton() {
    if (!isDesktop()) return;

    var originalLink = getOriginalLink();
    var primaryList = getPrimaryList();
    if (!originalLink || !primaryList) return;

    // Find existing injected item OR create it
    var li = primaryList.querySelector(".chevi-header-search-item");
    var btn;

    if (!li) {
      li = document.createElement("li");
      li.className = "header__primary-nav-item chevi-header-search-item";

      btn = document.createElement("button");
      btn.type = "button";
      btn.className = "chevi-header-search-link chevi-search-trigger";

      // Match typography if menu uses h6
      var firstMenuLink = primaryList.querySelector("a, summary");
      if (firstMenuLink && firstMenuLink.classList.contains("h6")) btn.classList.add("h6");

      // Keep aria-controls aligned with the theme
      var controls = originalLink.getAttribute("aria-controls");
      if (controls) btn.setAttribute("aria-controls", controls);

      // Click opens the theme search
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        originalLink.click();
      });

      li.appendChild(btn);

      // Insert after first item (your original behavior)
      var firstItem = primaryList.querySelector("li");
      if (firstItem && firstItem.nextSibling) primaryList.insertBefore(li, firstItem.nextSibling);
      else primaryList.appendChild(li);
    } else {
      btn = li.querySelector(".chevi-search-trigger");
    }

    if (!btn) return;

    // Always update label (this is the key for localization)
    var label = getTranslatedSearchLabel(originalLink);

    // Set text content cleanly (preserve caret)
    btn.setAttribute("aria-label", label);

    // Rebuild content so it doesn't duplicate on repeated runs
    btn.textContent = "";
    btn.appendChild(document.createTextNode(label.toUpperCase()));

    var caret = document.createElement("span");
    caret.className = "chevi-header-search-caret";
    caret.setAttribute("aria-hidden", "true");
    btn.appendChild(caret);
  }

  // Run on initial load
  document.addEventListener("DOMContentLoaded", ensureInjectedButton);

  // Run when Shopify re-renders sections (language/country switches often trigger this)
  document.addEventListener("shopify:section:load", ensureInjectedButton);

  // Extra safety: some language switches do a soft navigation
  window.addEventListener("pageshow", ensureInjectedButton);

  // Optional: run shortly after clicks on localization selectors
  document.addEventListener("click", function (e) {
    if (e.target.closest(".localization-selector, .localization-selectors, [data-localization]")) {
      setTimeout(ensureInjectedButton, 400);
      setTimeout(ensureInjectedButton, 1200);
    }
  });
})();
